import './polyfills'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from './components/SidebarPlugin'
import NotificationPlugin from './components/NotificationPlugin'

// element ui language configuration
import { ElConfigProvider } from 'element-plus'
import en from 'element-plus/es/locale/lang/en'

// asset imports
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/light-bootstrap-dashboard.scss'

export default {
  async install(app) {

    app.config.devtools = true


    app.use(GlobalComponents)
    app.use(GlobalDirectives)
    app.use(SideBar)
    app.use(NotificationPlugin)

    // Optional: wrap your app in ElConfigProvider in App.vue or main layout
    app.component(ElConfigProvider.name, ElConfigProvider)
  }
}
